import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onBeforeMount } from "vue";
// import setting from "@/config/default/setting.config";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

var img = new Image();
img.src = "./favicon.ico"; // 替换为你的图片路径
img.height = 16; // 设置图片大小，小于标题字体大小
img.width = 16;
onBeforeMount(() => {
  document.title = "四川大学研工系统服务大厅";
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})